import { ActionContext, ActionTree, Commit, DispatchOptions } from "vuex"
import MUTATION_TYPES from "./mutation-types"
import * as api from "../../api"
import { fissionProc, TaskProcessQueryBody, TaskProcQueryBody, TaskProcQueryBodyRuleItem, TotalTaskProcessQueryBody } from "../../api"
import type { GetActivityProcTokenExtendParams } from "../../../../api/game"
import * as gameApi from "../../../../api/game"
import type { ActivityForUsers } from "../../config"
import * as config from "../../config"
import { GiftTaskConfigItem } from "../../config"
import WechatRealname from "../../../../utils/wechat_realname"
import { checkTimeValid, safeStringify, UTC8TimeToTimeStamp } from "../../helper"
import Wechat from "../../../../utils/wechat"
import * as report from "../../../../utils/report"
import * as couponsApi from "../../../../api/coupon"
import { AppleGiftCardState, UserRole, UserZone } from "./state"
import { AppleGiftCardGetterInstance } from "./getters"
import { CONTRACT_STATUS } from "../../constant"
import { RootGetterInstance, RootState } from ".."
import Vue from "vue"
import * as Sentry from "@sentry/browser"
import * as url from "../../../../utils/url"
import { MobileZone } from "@tencent/midas-widgets-domestic"
import { cgi } from "@tencent/midas-cgi"
import { LoginSession } from "../../../qb-consume/store/qb-consume/getters"
import { session_skey, session_wechat, sessionObj } from "@tencent/midas-util"
import { getAuthPrivacy, setAuthPrivacy } from "../../../../api/privacy"
// import { aegis } from "../../../../installs/aegis"
import { checkIfUserAgreed, privacyEnums } from "../../../../business/auth"
import { cmallQuery } from "../../../../api/recommend"

const errorHandler = (e: Error): void => {
  // aegis.error(e)
  console.error(e)
  Sentry.captureException(e) // 主动上报错误
}
Vue.config.errorHandler = errorHandler

interface DispatchActions {
  <K extends keyof AppleGiftCardActions>(type: K, payload?: Parameters<AppleGiftCardActions[K]>[1], options?: DispatchOptions): ReturnType<
    AppleGiftCardActions[K]
  >
}
interface EnhanceAppleGiftCardActionContext<S, R> extends ActionContext<S, R> {
  dispatch: DispatchActions
  commit: Commit
  state: S
  getters: AppleGiftCardGetterInstance // vuex给出的ActionContext接口对getters没有具体声明，故有此加强接口
  rootState: R
  rootGetters: RootGetterInstance
}

export interface PayProps {
  mid: string
  token_id: string
  groupid?: string
  codeId?: string
  batchId?: string
}

interface QuerySignContractResponseBody {
  ret: number
  info: {
    contract_status: CONTRACT_STATUS
    mask_id: string
  }
}

interface GetAppleSignUrlResponseBody {
  ret: number
  info: {
    contract_url: string
  }
}

interface CancelAppleSignResponseBody {
  ret: number
  info: Record<string, never>
}

interface QueryDRMLimitResponseBody {
  ret: number
  info: {
    limit_info: {
      resop_mpinfo: {
        total_num: number
        limit_type: string
        detail: {
          product_id: string
          used_quota: number // 已使用额度（通常使用这个字段判断当前用户是否已领取）
          uin_quota: number // 用户限额
          total_quota: number // 总额度
        }[]
      }
    }
  }
}

interface QueryDRMLimitParams {
  action: string
  drm_info: string // 透传drm信息
  buy_type: string // 限制所属购买类型
  product_list?: string // 查询的物品列表，多个物品逗号分隔
  query_total?: number // 是否查询总量
  use_commid?: number // 使用commid进行查询，微信登录态下有效
  use_other_openid?: number // 使用offerid对应业务的openid进行查询，微信登录态下有效
  provide_uin?: number // 按承载QQ号查询，只在微信登录态下有效
}
export enum NewbiePresentStatus {
  UnQualified = "0",
  Qualified = "1",
  Received = "2"
}
export interface NewbieTaskDetail {
  presentStatus: NewbiePresentStatus
  shown: boolean
  presentImg: string
  presentName: string
  presentDesc: string
}

export interface AppleLadderTaskDetail {
  hasReceivedOneOfPresents: boolean
  rankInfo: Array<{
    rank: string
    hasReceived: boolean
    ccbTaskRewardIndex: number //档位索引决定阶梯任务显示在哪里
    presentImg: string
    presentName: string
    presentDesc: string
  }>
}

export interface AppleGiftCardActions {
  getLoginState: (ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>) => Promise<any>
  querySignContract: (ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>) => Promise<QuerySignContractResponseBody>
  getWechatRealnameInfo: (ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>) => Promise<void>
  getAppleSignUrl: (
    ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>,
    payload: { mobile: string }
  ) => Promise<GetAppleSignUrlResponseBody>
  cancelAppleSign: (ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>) => Promise<CancelAppleSignResponseBody>
  getUserType: (ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>) => Promise<string>
  getActivityByUserType: (ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>) => Promise<ActivityForUsers | undefined>
  filterUserTypeProductItem: (
    ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>,
    payload: { activity: ActivityForUsers; excludeGroupId?: boolean }
  ) => void
  queryDRMLimit: (
    ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>,
    activity?: ActivityForUsers
  ) => Promise<any> | undefined
  filterProductItem: (ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>, group_id: string) => any
  placeOrder: (
    ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>,
    payload: { quantity: number; groupid?: string }
  ) => Promise<gameApi.GetActivityProcTokenResponseBody>
  pay: (
    ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>,
    payload: PayProps
  ) => Promise<api.MobileSaveGoodsResponseBody>
  wechatPay: (ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>, wxInfo: any) => Promise<any>
  reportUserAction: (ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>, payload: any) => void
  reportError: (ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>, payload: Error) => void
  queryUserAvailableCoupons: (ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>) => void
  getCoupons: (ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>, payload: { priceList: any }) => Promise<any>
  openCouponDialog: (
    ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>,
    payload: {
      events: {
        selectCoupons: (selectedCoupon: any) => void
        needSelectedCoupons: (callback: any) => void
      }
      totalPrice: number
    }
  ) => void
  hideCouponDialog: (ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>) => void
  setSelectedCoupon: (ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>, coupon: any) => void
  setToastMsg: (
    ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>,
    params: { toastMsg: string; cb?: (...arg: any[]) => any }
  ) => number | undefined
  taskProcessQuery: (
    ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>,
    payload: { offerId: string; groupId: string; taskId: string; monthTaskId?: string; timeout?: number }
  ) => Promise<TaskProcessQueryBody>
  taskProcQuery: (
    ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>,
    payload: { offerId: string; groupId: string }
  ) => Promise<TaskProcQueryBody>
  ccbTaskProcQuery: (
    ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>,
    payload: { offerId: string; groupId: string }
  ) => Promise<TaskProcQueryBody>
  totalTaskProcessQuery: (
    ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>,
    payload: { offerId: string; groupId: string; taskId: string; monthTaskId: string }
  ) => Promise<TotalTaskProcessQueryBody>
  getTaskPresent: (
    ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>,
    payload: { offerId: string; groupId: string; taskId: string; presentRank: string; provide_no?: string }
  ) => Promise<{ ret: number }>
  setUserZoneRoleFromCGIData: (ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>, cgi_data: string) => void
  PersistZoneRole: (ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>, taskConfig: GiftTaskConfigItem) => Promise<void>
  getTaskSession: (
    ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>,
    payload: { loginState: LoginSession; userAgent: any }
  ) => sessionObj
  getAuthPrivacy: (ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>) => void
  setAuthPrivacy: (ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>) => void
  checkUserAgreedAuth: (ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>) => void
  getMyFission: (ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>) => Promise<string>
  getNewbieTask: (ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>) => Promise<NewbieTaskDetail | null>
  getLadderTask: (
    ctx: EnhanceAppleGiftCardActionContext<AppleGiftCardState, RootState>,
    payload: { taskId: string; groupId: string; weekCcbTask: TaskProcQueryBodyRuleItem; offerId: string }
  ) => Promise<AppleLadderTaskDetail | null>
}

const actions: AppleGiftCardActions & ActionTree<AppleGiftCardState, RootState> = {
  getLoginState({ state, commit }) {
    return new Promise((resolve, reject) => {
      if (!(state.userAgent.weixin && state.userAgent.iOS)) {
        reject({
          err: 8889,
          msg: "请复制地址，在iOS端微信打开"
        })
        return
      }

      const wechat = new Wechat({
        context: "loginState",
        getDetail: 1
      })
      if (wechat.init()) {
        wechat.getOpenid({
          onSuccess: function (this: Wechat) {
            try {
              commit(MUTATION_TYPES.SET_LOGIN_STATE, {
                openid: this.openid,
                openkey: this.accessToken,
                sessionId: "hy_gameid",
                sessionType: "wc_actoken"
              })
              commit(MUTATION_TYPES.SET_USER_INFO, {
                nick: encodeURIComponent(this.info!.nickname),
                head_img_url: encodeURIComponent(this.info!.headimgurl)
              })
              resolve(null)
            } catch (e) {
              reject({ err: 8888, msg: "获取登陆态失败,请重试" })
            }
          },
          onError: () => {
            reject({ err: 8888, msg: "获取登陆态失败,请重试" })
          }
        })
      }
    })
  },
  // 查询签约状态
  querySignContract({ state, getters, dispatch }) {
    dispatch("reportUserAction", {
      iformat: config.REPORT.PAGEVIEW.QUERY_SIGN_CONTRACT
    })
    return api.rechargeCard<QuerySignContractResponseBody>(
      Object.assign(
        {
          sandbox: state.sandbox,
          action: "apple_sign_query",
          offerId: state.offerId
        },
        getters.loginState
      )
    )
  },
  getWechatRealnameInfo({ state, getters, commit, dispatch }) {
    dispatch("reportUserAction", {
      iformat: config.REPORT.PAGEVIEW.GET_WECHAT_REALNAME_INFO
    })
    return new Promise<void>((resolve, reject) => {
      if (state.wechatRealnameToken) {
        resolve()
      } else {
        const wechatRealname = new WechatRealname({
          context: "realname"
        })
        if (wechatRealname.init()) {
          wechatRealname.getRealInfo(
            Object.assign(
              {
                sandbox: state.sandbox,
                offerId: state.offerId,
                onSuccess: function (this: WechatRealname) {
                  commit(MUTATION_TYPES.SET_WECHAT_REALNAME_TOKEN, this.accessToken)
                  resolve()
                },
                onError: reject
              },
              getters.loginState
            )
          )
        }
      }
    })
  },
  // 获取签约url
  getAppleSignUrl({ state, getters }, { mobile }) {
    return api.rechargeCard<GetAppleSignUrlResponseBody>(
      Object.assign(
        {
          sandbox: state.sandbox,
          action: "apple_sign_get_url",
          offerId: state.offerId,
          wx_pay_access_token: state.wechatRealnameToken,
          // mobile: "18617007813",
          mobile
          // email: "357323350@qq.com",
          // province: "gd",
          // city: "shenzhen"
        },
        getters.loginState
      )
    )
  },
  // 解约
  cancelAppleSign({ state, getters }) {
    return api.rechargeCard<CancelAppleSignResponseBody>(
      Object.assign(
        {
          sandbox: state.sandbox,
          action: "apple_sign_cancel",
          offerId: state.offerId
        },
        getters.loginState
      )
    )
  },
  async getUserType({ getters, state, commit }) {
    const results = await cmallQuery("26", {
      ...getters.loginState,
      from_h5: 1,
      pf: `mds_wechat_qb-${state.pf}-html5`,
      pfkey: "pfkey",
      model: "apple_card_new_user",
      sandbox: state.sandbox,
      offerId: state.offerId
    })
    return results.recomm_info.score == "1" ? "olduser" : "newuser"
  },
  /**
   * 根据用户身份返回活动号
   * @param getters
   * @param state
   * @param dispatch
   */
  async getActivityByUserType({ state, dispatch, commit }) {
    try {
      const activities =
        state.configInfo.activityForUsers && state.configInfo.activityForUsers?.filter(act => checkTimeValid(act.start_time, act.end_time))
      //有按用户返回身份的活动
      if (activities && activities?.length > 0) {
        //先拿到用户身份
        const userType = await dispatch("getUserType")
        //根据用户身份返回活动号=
        const results = activities?.find(act => act.usertype === userType)
        commit(MUTATION_TYPES.SET_USER_TYPE_ACTIVITY, results)
        return results
      }
    } catch (e) {
      throw {
        //拿身份活动失败提示用户重试
        err: 1111,
        msg: "系统繁忙，请重试进入"
      }
    }
  },
  filterUserTypeProductItem({ commit }, { activity, excludeGroupId = false }) {
    const productItems = activity.nums.split(",").map(num => ({
      num,
      groupid: excludeGroupId ? undefined : activity.group_id,
      groupid_price: (~~num * 100 * Number(activity.discount)) / 100,
      start_time: activity.start_time,
      end_time: activity.end_time,
      resident: true
    }))

    commit(MUTATION_TYPES.SET_GOODS_PRICE_ITEM_INFO, productItems)
  },
  // drm限制查询
  async queryDRMLimit({ getters, state, dispatch, commit }, userTypeSpecificActivity) {
    try {
      if (!getters.fullDiscountValid && !userTypeSpecificActivity) {
        await dispatch("filterProductItem")
        dispatch("reportUserAction", {
          iformat: config.REPORT.PAGEVIEW.FILTER_ITEMS,
          resultInfo: state.productItem
        })
        return
      }
      dispatch("reportUserAction", {
        iformat: config.REPORT.PAGEVIEW.DRM_LIMIT_QUERY
      })

      const params: QueryDRMLimitParams = {
        action: "drm_limit_query",
        buy_type: "buygoods",
        drm_info: `group_id=${userTypeSpecificActivity?.group_id ?? state.configInfo.activityInfo.group_id}`,
        use_commid: 1
      }

      // const res = await api.followActivity<QueryDRMLimitResponseBody>({
      //   ...params,
      //   ...getters.loginState,
      //   offerId: state.offerId,
      //   sandbox: state.sandbox,
      //   pf: `mds_wechat_qb-${state.pf}-html5`
      // })
      //这里改成用户是否有裂变id来判断是否有资格

      const fissionId = await dispatch("getMyFission")

      // const detail = res?.info?.limit_info?.resop_mpinfo?.detail?.[0]
      if (fissionId && userTypeSpecificActivity?.usertype === "newuser") {
        //用户无资格了
        // if (userTypeSpecificActivity) {
        //   void dispatch("filterUserTypeProductItem", { activity: userTypeSpecificActivity, excludeGroupId: true })
        // } else {
        dispatch("filterProductItem", state.configInfo.activityInfo.group_id)
        // }
        commit(MUTATION_TYPES.SET_USER_NOT_QUALIFIY_FULL_DISCOUNT, false)
      } else {
        if (userTypeSpecificActivity) {
          void dispatch("filterUserTypeProductItem", { activity: userTypeSpecificActivity })
        } else {
          dispatch("filterProductItem")
        }
      }
    } catch (e) {
      if (userTypeSpecificActivity) {
        void dispatch("filterUserTypeProductItem", { activity: userTypeSpecificActivity })
      } else {
        dispatch("filterProductItem")
      }
      dispatch("reportUserAction", {
        iformat: config.REPORT.PAGEVIEW.DRM_LIMIT_QUERY_FAIL,
        resultInfo: e
      })
    } finally {
      dispatch("reportUserAction", {
        iformat: config.REPORT.PAGEVIEW.FILTER_ITEMS,
        resultInfo: state.productItem
      })
    }
  },
  filterProductItem({ state, commit }, excludeGroupId) {
    const productItem = state.configInfo.BUY_COLUMN.filter(
      //过滤常驻档位或者当前活动号处于有效期的档位
      item => item.resident || (item.groupid && checkTimeValid(item.start_time, item.end_time))
    )?.map(item => {
      const column = Object.assign({}, item)
      //把活动不在有效期内的场景下groupid清空以便后面支付的时候不带上活动号
      if (item.groupid && item.groupid != excludeGroupId && checkTimeValid(item.start_time, item.end_time)) {
        return column
      } else {
        column.groupid = undefined
        return column
      }
    })
    commit(MUTATION_TYPES.SET_GOODS_PRICE_ITEM_INFO, productItem)
  },
  placeOrder({ state, getters }, { quantity, groupid }) {
    const extendParams: GetActivityProcTokenExtendParams = {
      is_v3_price: 1,
      zoneid: 1,
      payitem: `${state.productId}*${quantity}*${state.offerId}`,
      goodsmeta: encodeURIComponent(`${state.productName}${quantity}`) + "*desc",
      app_metadata: JSON.stringify({
        offer_id: state.activityOfferId || "",
        tx_trace_key: state.tx_trace_key || ""
      })
    }
    if (groupid) {
      extendParams.drm_info = `group_id=${groupid}&version=3.0`
    }
    return gameApi.getActivityProcToken(
      {
        sandbox: state.sandbox,
        offerId: state.offerId,
        openid: state.openid,
        openkey: state.openkey,
        sessionId: state.sessionId,
        sessionType: state.sessionType,
        wxAppid2: state.wx_appid,
        pf: `${getters.pfSource}-${state.pf}-html5`
      },
      extendParams
    )
  },
  pay({ state, getters }, { mid, token_id, groupid, codeId, batchId }) {
    const params: api.MobileSaveGoodsParams = {
      ...getters.loginState,
      sandbox: state.sandbox,
      offerId: state.offerId,
      pf: `${getters.pfSource}-${state.pf}-html5`,
      token_id,
      pay_method: "bank_unionpay:1",
      mid
    }

    // 抵扣券参数
    if (codeId && batchId) {
      params.sp_info = `${codeId},${batchId}`
    }
    if (groupid) {
      params.drm_info = `group_id=${groupid}&version=3.0`
    }
    return api.mobileSaveGoods(params)
  },
  wechatPay({ state }, wxInfo) {
    return new Promise((resolve, reject) => {
      const wechat = new Wechat()
      wechat.buy(
        {
          onSuccess: () => {
            resolve(state)
          },
          onError: reject
        },
        wxInfo
      )
    })
  },
  reportUserAction({ state }, params): void {
    const data = {
      3: state.openid,
      13: 1,
      21: params.iformat,
      26: `mds_wechat_qb-${state.pf || "pay_html5"}-html5`,
      24: state.offerId,
      37: state.sessionId,
      43: state.sessionType,
      41: state.wx_appid,
      50: navigator.userAgent,
      51: "",
      36: location.href
    }
    try {
      report.dataReport({ ...data, ["8"]: safeStringify(params.resultInfo || "") })
    } catch (e) {
      report.dataReport({ ...data, ["8"]: safeStringify(e || "") })
    }
  },
  reportError(ctx, e: Error): void {
    errorHandler(e)
  },
  queryUserAvailableCoupons({ dispatch, state, commit }) {
    dispatch("getCoupons", { priceList: state.configInfo.BUY_COLUMN.map(col => col.num) }).then(
      (coupons?: {
        [key: string]: {
          threshold: number
          cardId: string
          batchId: string
          saving: number
          codeId: string
          status?: any
          name: string
        }
      }) => {
        if (coupons) {
          commit(MUTATION_TYPES.SET_AVAILABLE_COUPON, coupons)

          // 拿到threshold最大的一张券
          const bestCoupon = Object.keys(coupons).sort((a, b) => Number(b) - Number(a))[0]
          dispatch("setSelectedCoupon", coupons[bestCoupon])
          dispatch("reportUserAction", {
            iformat: config.REPORT.PAGEVIEW.COUPON_VIEW,
            resultInfo: coupons
          })
        }
      }
    )
  },
  getCoupons({ getters, state }, { priceList }) {
    return couponsApi
      .getRecommendList(priceList, {
        pfSource: getters.pfSource,
        pf2rd: state.pf,
        openid: getters.loginState.openid,
        openkey: getters.loginState.openkey,
        sessionid: getters.loginState.session_id,
        sessiontype: getters.loginState.session_type,
        appid: state.offerId,
        sandbox: state.sandbox,
        productId: state.productId
      })
      .then(recommendList => {
        if (recommendList.status && recommendList.data.length > 0) {
          const recommendObj: Record<string, unknown> = {}
          recommendList.data.forEach(item => {
            recommendObj[item.price_level] = {
              threshold: item.coupon.least_price,
              cardId: item.coupon.card_id,
              batchId: item.coupon.batch_id,
              saving: item.coupon.amt,
              codeId: item.coupon.code_id,
              status: item.coupon.state,
              name: item.coupon.name || ""
            }
          })
          return Promise.resolve(recommendObj)
        }
      })
      .catch(null)
  },
  openCouponDialog({ getters, state }, { events, totalPrice }) {
    couponsApi.openDialog({
      params: {
        openid: getters.loginState.openid,
        openkey: getters.loginState.openkey,
        sessionid: getters.loginState.session_id,
        sessiontype: getters.loginState.session_type,
        appid: state.offerId,
        pf2rd: state.pf,
        pfSource: getters.pfSource,
        totalPrice, //TODO 为什么有两个totalPrice
        productid: state.productId
      },
      totalPrice, //TODO 为什么有两个totalPrice
      env: state.sandbox,
      simpleProtocal: true,
      events
    })
  },
  hideCouponDialog() {
    couponsApi.hideDialog()
  },
  setSelectedCoupon({ commit }, coupon) {
    commit(MUTATION_TYPES.SET_SELECTED_COUPON, coupon)
  },
  setToastMsg({ commit, state }, { toastMsg, cb }: { toastMsg: string; cb?: (...arg: any[]) => any }) {
    commit(MUTATION_TYPES.SET_TOAST_MSG, toastMsg)
    if (state.toastMsgTimer) clearTimeout(state.toastMsgTimer)
    if (toastMsg) {
      const timer = window.setTimeout(() => {
        if (state.toastMsg) {
          commit(MUTATION_TYPES.SET_TOAST_MSG, "")
        }
        cb?.()
      }, 2000)
      commit(MUTATION_TYPES.SET_TOAST_MSG_TIMER, timer)
      return timer
    }

    commit(MUTATION_TYPES.SET_TOAST_MSG_TIMER, null)
  },
  taskProcessQuery(
    { state, getters },
    {
      offerId,
      groupId,
      taskId,
      monthTaskId,
      timeout
    }: { offerId: string; groupId: string; taskId: string; monthTaskId?: string; timeout?: number }
  ) {
    return new Promise((resolve, reject) => {
      api
        .taskProcessQuery(
          {
            ...getters.loginState,
            sandbox: state.sandbox,
            offerId,
            drm_info: encodeURI(`version=3.0&group_id=${groupId}`),
            task_id_list: encodeURI([taskId, monthTaskId].filter(v => v).join(","))
          },
          {
            timeout
          }
        )
        .then(res => {
          resolve(res)
        })
        .catch(e => reject(e))
    })
  },
  taskProcQuery({ state, getters }, { offerId, groupId }: { offerId: string; groupId: string }) {
    return api.taskProcQuery({
      ...getters.loginState,
      offerid: offerId,
      sandbox: state.sandbox,
      drm_info: encodeURI(`version=3.0&group_id=${groupId}`)
    })
  },
  ccbTaskProcQuery({ state, getters }, { offerId, groupId }: { offerId: string; groupId: string }) {
    return api.ccbTaskProcQuery({
      ...getters.loginState,
      offerid: offerId,
      sandbox: state.sandbox,
      drm_info: encodeURI(`version=3.0&group_id=${groupId}`)
    })
  },
  totalTaskProcessQuery(
    { state, getters },
    { offerId, groupId, taskId, monthTaskId }: { offerId: string; groupId: string; taskId: string; monthTaskId: string }
  ) {
    return api.totalTaskProcessQuery({
      ...getters.loginState,
      offerId,
      sandbox: state.sandbox,
      task_id_list: encodeURI(`${taskId},${monthTaskId}`),
      drm_info: encodeURI(`version=3.0&group_id=${groupId}`)
    })
  },
  /**
   * 领取任务奖励
   */
  async getTaskPresent({ state, getters }, { offerId, presentRank, groupId, taskId, provide_no }) {
    if (state.selectedZone && state.selectedRole) {
      const results = await api.getTaskPresent({
        offerId,
        loginState: getters.loginState,
        sandbox: state.sandbox,
        userZone: state.selectedZone,
        userRole: state.selectedRole,
        presentRank,
        groupId,
        taskId,
        provide_no
      })
      return results
    } else {
      throw new Error("缺少大区角色信息")
    }
  },
  /**
   * cgi_data转出用户大区角色对象
   * cgi_data: "game_platform_id=0&gameid=2___2081&zone_name=%E6%89%8BQ71%E5%8C%BA-%E5%BC%82%E5%9F%9F%E8%88%9E%E5%A8%98&zoneid=2081"
   * @param cgi_data
   */
  setUserZoneRoleFromCGIData({ commit }, cgi_data: string): void {
    const gameid = url.getParam("gameid", cgi_data)?.split("_")
    const userZone: UserZone = {
      zone_id: url.getParam("zoneid", cgi_data),
      zone_name: decodeURIComponent(url.getParam("zone_name", cgi_data)),
      partition_info: {
        game_platform_id: url.getParam("game_platform_id", cgi_data),
        partition: gameid[gameid.length - 1],
        area: gameid[0]
      }
    }
    const userRole: UserRole = {
      supportRole: false,
      role_id: gameid[1],
      role_name: decodeURIComponent(gameid[2])
    }
    commit(MUTATION_TYPES.SET_USER_ZONE, userZone)
    commit(MUTATION_TYPES.SET_USER_ROLE, userRole)
  },
  /**
   * 持久化大区选择
   */
  async PersistZoneRole({ state, getters, commit, dispatch }, taskConfig: GiftTaskConfigItem): Promise<void> {
    const sessionObj = await dispatch("getTaskSession", {
      loginState: getters.loginState,
      userAgent: state.userAgent
    })
    const Cgi = new cgi({
      pf: `mds_wechat_qb-${state.pf}-${state.userAgent.android ? "android" : "iap"}`,
      appid: taskConfig.offerId,
      sandbox: 0,
      sessionObj,
      version: "h5_applecard"
    })
    const mobileZoneSelector = new MobileZone.DialogApi({
      cgiObj: Cgi,
      options: {
        cmall_query: false,
        recommModel: {
          android: state.recommModel?.android,
          iOS: state.recommModel?.iOS
        }
      }
    })
    // 查询角色推荐，如果没有角色推荐就取localStorage
    mobileZoneSelector.parseCachedZoneRole().then((res: any) => {
      if ((res?.ret !== undefined && res.ret !== 0) || !res) return
      commit(MUTATION_TYPES.SET_USER_ZONE, {
        zone_name: res?.[0]?.zone_name,
        zone_id: res?.[0]?.zone_id,
        partition_info: {
          area: res?.[1]?.partition_info?.area,
          partition: res?.[1]?.partition_info?.partition,
          game_platform_id: res?.[1]?.partition_info?.platid
        }
      })
      commit(MUTATION_TYPES.SET_USER_ROLE, {
        supportRole: res?.[1]?.support_role == "1",
        role_id: res?.[1]?.role_id,
        role_name: res?.[1]?.role_name
      })
    })
  },
  /**
   * 获取参加任务的登录态
   * QB场景根据用户环境选择
   * @param loginState
   * @param userAgent
   */
  getTaskSession(
    ctx,
    {
      loginState,
      userAgent
    }: {
      loginState: LoginSession
      userAgent: any
    }
  ): sessionObj {
    if (userAgent.weixin) {
      return new session_wechat({
        openid: loginState.openid,
        accessToken: loginState.openkey,
        appid: loginState.wx_appid || Wechat.defaultAppid
      })
    } else if (userAgent.QQ) {
      return new session_skey({
        uin: loginState.openid,
        skey: loginState.openkey
      })
    } else {
      throw new Error("不支持的环境")
    }
  },
  getAuthPrivacy({ state, getters, commit, dispatch }) {
    getAuthPrivacy({
      sandbox: state.sandbox,
      offerId: state.offerId,
      loginState: getters.loginState
    })
      .then(results => {
        const authorized = !!results?.find(item => item.groupId == state.appleCardGroupId)?.authorized
        commit(MUTATION_TYPES.SET_AGREE_CHECKED, authorized)
        dispatch("reportUserAction", {
          iformat: config.REPORT.PAGEVIEW.GET_PRIVACY_SUC
        })
      })
      .catch(e => {
        dispatch("reportUserAction", {
          iformat: config.REPORT.PAGEVIEW.GET_PRIVACY_ERROR,
          resultInfo: e
        })
      })
  },
  setAuthPrivacy({ state, getters, dispatch }) {
    setAuthPrivacy({
      sandbox: state.sandbox,
      offerId: state.offerId,
      loginState: getters.loginState,
      subject_id: state.appleCardGroupId,
      authorization: privacyEnums.agree
    })
      .then(() => {
        dispatch("reportUserAction", {
          iformat: config.REPORT.PAGEVIEW.SET_PRIVACY_SUC
        })
      })
      .catch(e => {
        dispatch("reportUserAction", {
          iformat: config.REPORT.PAGEVIEW.SET_PRIVACY_ERROR,
          resultInfo: e
        })
      })
  },
  checkUserAgreedAuth({ state, commit }) {
    const authorized = checkIfUserAgreed(state.appleCardGroupId)
    commit(MUTATION_TYPES.SET_AGREE_CHECKED, authorized)
  },
  async getMyFission({ state, getters }) {
    const results = await fissionProc(
      {
        offerId: state.offerId,
        loginState: getters.loginState,
        sandbox: state.sandbox,
        pf: state.pf
      },
      {
        action: "query_my_fissions",
        drm_info: `version=3.0&group_id=${state.configInfo.fission.fissionGroupid}`,
        page_size: 10,
        cur_page: 1
      }
    )
    //裂变时间需要在活动时间内
    const fissionList =
      getters.fissionActivityValid &&
      results?.info?.fission_data?.fission_info?.generate?.filter(fission => {
        //生成裂变的时间需要在活动时间内
        return (
          UTC8TimeToTimeStamp(state.configInfo.fission.begin_time) <= fission.begin_time * 1000 &&
          UTC8TimeToTimeStamp(state.configInfo.fission.end_time) >= fission.end_time * 1000
        )
      })

    return fissionList?.[0]?.fission_id
  },
  getNewbieTask({ state, getters }) {
    return api
      .getNewbieTask({
        offerId: state.offerId,
        sandbox: state.sandbox,
        pf: state.pf,
        loginState: getters.loginState
      })
      .then(results => {
        const taskDetail: NewbieTaskDetail = {
          shown: !!results?.info?.show_present,
          presentStatus: results?.info?.present_state as NewbiePresentStatus,
          presentImg: results?.info?.present_image,
          presentDesc: results?.info?.present_desc,
          presentName: results?.info?.present_name
        }
        return taskDetail
      })
      .catch(() => {
        return null
      })
  },
  getLadderTask({ state, getters }, { offerId, taskId, groupId, weekCcbTask }) {
    return api
      .getLadderTask({
        offerId,
        sandbox: state.sandbox,
        pf: state.pf,
        loginState: getters.loginState,
        taskId,
        groupId
      })
      .then(results => {
        const mapped: Record<string, any> = {}
        results?.info?.rank_info?.forEach((info: { rank: string; limited: boolean }) => {
          weekCcbTask?.present_item.forEach((reward, index) => {
            if (+info.rank <= +reward.num) {
              if (!mapped[info.rank]?.rank || +reward.num <= mapped[info.rank]?.rank) {
                mapped[info.rank] = { index, rank: reward.num } //先找到阶梯门槛能匹配到充充币的哪个档位
              }
            }
          })
        })
        Object.keys(mapped)?.forEach(item => {
          Object.keys(mapped).forEach(inner => {
            if (mapped[item].index === mapped[inner].index && item < inner) {
              //如果有相同阶梯门槛匹配到同一个充充币档位,以最高的档位为准
              //例如300,500的阶梯，充充币的门槛是100,600那么600档应该是可以领取500门槛的阶梯奖励
              mapped[item].index = -1
            }
          })
        })
        const detail: AppleLadderTaskDetail = {
          hasReceivedOneOfPresents: results?.info?.ccb_present_limited,
          rankInfo: results?.info?.rank_info
            .map((item: { rank: string; limited: boolean; present_image: string; present_name: string; present_desc: string }) => {
              return {
                rank: item.rank,
                hasReceived: item.limited,
                ccbTaskRewardIndex: mapped?.[item.rank]?.index || -1,
                presentImg: item.present_image,
                presentName: item.present_name,
                presentDesc: item.present_desc
              }
            })
            .filter(item => item.ccbTaskRewardIndex > -1)
        }
        return detail
      })
      .catch(() => {
        return null
      })
  }
}
export default actions
